// Recently-viewed products, tracked client-side via localStorage.
// This file only READS the list (used on the "Recommended for you"
// section). To populate it, sections/fresh-main-product.liquid logs a
// view every time someone visits an ALRehmat Fresh product page.

window.FreshRecentlyViewed = {
  STORAGE_KEY: 'alrehmat_fresh_recently_viewed',
  MAX_ITEMS: 6,

  log: function (product) {
    try {
      var list = this.getAll().filter(function (p) { return p.handle !== product.handle; });
      list.unshift(product);
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(list.slice(0, this.MAX_ITEMS)));
    } catch (e) { /* localStorage unavailable — fail silently */ }
  },

  getAll: function () {
    try {
      var raw = localStorage.getItem(this.STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  },

  render: function (imgSlot, titleSlot, anchorSlot, ctaSlot) {
    var items = this.getAll();
    if (!items.length) return false;
    var p = items[0];
    imgSlot.innerHTML = '<img src="' + p.image + '" width="150" height="150" alt="' + p.title + '">';
    if (titleSlot) titleSlot.textContent = p.title;
    if (anchorSlot) anchorSlot.href = p.url;
    if (ctaSlot) ctaSlot.href = p.url;
    return true;
  }
};

document.addEventListener('DOMContentLoaded', function () {
  var imgSlot = document.querySelector('[data-fresh-recently-viewed]');
  var titleSlot = document.querySelector('[data-fresh-recently-viewed-title]');
  var anchorSlot = document.querySelector('[data-fresh-recently-viewed-anchor]');
  var ctaSlot = document.querySelector('[data-fresh-recently-viewed-cta]');
  var card = document.querySelector('[data-fresh-recently-viewed-card]');
  if (imgSlot && window.FreshRecentlyViewed.render(imgSlot, titleSlot, anchorSlot, ctaSlot)) {
    if (card) card.hidden = false;
  }
});
